import {addLanguage} from '../../redux/reducers/languageSlice'
import {useDispatch} from 'react-redux'
import {addCohort} from '../../redux/reducers/cohortSlice'
import {useNavigate} from 'react-router-dom'
import api from '../../../_metronic/helpers/api'
import {showAlert} from '../../redux/reducers/alertSlice'
import {stringify} from 'qs'
import {addSeason} from '../../redux/reducers/seasonSlice'
function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const handleEdit = async (id) => {
    try {
      const response = await api.get(
        `/unit/${id}?relations[]=unitVideo.video&relations[]=cohort&relations[]=language&relations[]=tag`
      )
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error.response.data.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const fetchAllUnits = async (text = null, status = null, cohortId = null, seasonId = null) => {
    const params = {
      relations: ['unitVideo.video', 'tag'],
      limit: 100,
      offset: 0,
      order: {createdAt: 'DESC'},
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }

    let allData = []
    let totalRecords = 0

    try {
      const initialResponse = await api.get(`/unit?${stringify(params)}`)
      if (initialResponse.data.status) {
        totalRecords = initialResponse.data.data.count
        allData = initialResponse.data.data.records

        const totalChunks = Math.ceil(totalRecords / params.limit)
        const promises = []

        for (let i = 1; i < totalChunks; i++) {
          params.offset = i * params.limit
          promises.push(api.get(`/unit?${stringify(params)}`))
        }

        const responses = await Promise.all(promises)
        responses.forEach((response) => {
          if (response.data.status) {
            allData = [...allData, ...response.data.data.records]
          }
        })

        if (allData?.length > 0) {
          return allData?.flatMap(
            (record) =>
              record?.unitVideo?.map((unitVideo) => ({
                id: record?.id,
                code: record?.code,
                name: record?.name,
                description: record?.description,
                cohort: record?.cohortId,
                language: record?.languageId,
                videoId: unitVideo?.videoId,
                videoTitle: unitVideo?.video?.title,
                videoLink: unitVideo?.video?.link,
                videoDescription: unitVideo?.video?.description,
                tags: record.tag ? record.tag.map((tag) => tag.name).join(', ') : '',
                season: record?.seasonId,
                ForBlackforceMember: record?.isForBlackforceMember || false,
              })) || []
          )
        }
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const editUnit = async (id, data) => {
    try {
      const response = await api.patch(`/unit/${id}`, data)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully Updated', variant: 'success'}))
        navigate('/unitlist')
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const publishUnit = async (data) => {
    try {
      const response = await api.post(`/unit`, data)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully added', variant: 'success'}))
        navigate('/unitlist')
        return fetchUnits()
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const deleteUnit = async (id, limit, offset) => {
    try {
      const response = await api.delete(`/unit/${id}`)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Successfully deleted', variant: 'success'}))
        return fetchUnits(null, null, null, null, limit, offset)
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const fetchUnits = async (
    text = null,
    status = null,
    cohortId = null,
    seasonId = null,
    limit = 10,
    offset = 0
  ) => {
    const params = {
      limit,
      offset,
      relations: ['cohort'],
      where: {},
      order: {createdAt: 'DESC'},
    }

    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }
    try {
      const response = await api.get(`/unit?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const fetchLanguages = async () => {
    try {
      const response = await api.get(
        `/language?select[id]=true&select[name]=true&select[createdAt]=true&order[name]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addLanguage(response.data.data))
      }
    } catch (error) {}
  }

  const fetchCohorts = async () => {
    try {
      const response = await api.get(
        `/cohort?select[id]=true&select[title]=true&select[createdAt]=true&order[title]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addCohort(response.data.data))
      }
    } catch (error) {}
  }

  const addCSV = async (data) => {
    try {
      const response = await api.post(`/unit/add-bulk`, data)
      if (response?.data?.status) {
        return response?.data?.data
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const fetchSeasons = async () => {
    const params = {
      returnAllRecords: true,
      offset: 0,
    }

    try {
      const response = await api.get(
        `/season?${stringify(params)}&select[id]=true&select[name]=true&order[name]=ASC`
      )
      if (response.data.status) {
        dispatch(addSeason(response.data.data))
      }
    } catch (error) {
      console.log(error?.message)
    }
  }
  const submitReport = async (data) => {
    try {
      const response = await api.post(`/setting/sendCSVReport`, data)
      return response
    } catch (error) {}
  }

  const refetchVideo = async (videoId) => {
    try {
      const response = await api.post(`/video/${videoId}/retry-vimeo`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const getVideo = async (videoId) => {
    try {
      const response = await api.get(`/video/${videoId}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  return {
    addCSV,
    editUnit,
    publishUnit,
    handleEdit,
    deleteUnit,
    fetchCohorts,
    fetchLanguages,
    fetchUnits,
    fetchAllUnits,
    fetchSeasons,
    submitReport,
    refetchVideo,
    getVideo,
  }
}

export default useUtils
